<template>
  <div class="submit" @click="this.$emit('onSubmit')">
    <div v-if="isLoading" class="loader"></div>
    <div v-else>Submit</div>
  </div>
</template>

<script>
export default {
  name: "SubmitButton",
  props: {
    visible: Boolean,
    enabled: Boolean,
    isLoading: Boolean,
  },
};
</script>

<style scoped>
.submit {
  display: inherit;
  width: 15%;
  max-width: 20%;
  border-radius: 100px;
  border: 2px solid black;
  background-color: #000;
  color: #fff;
  font-family: Work Sans, serif;
  font-size: 20px;
  font-weight: 400;
  cursor: pointer;
  padding: 9px 29px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.submit:hover {
  background-color: transparent;
  color: #000;
}

.loader {
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 2px;
  text-indent: -9999em;
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: #ffffff;
  background: -moz-linear-gradient(
    left,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #ffffff;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.loader:after {
  background: #000000;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.submit:hover .loader {
  background: #fff;
  background: -moz-linear-gradient(left, #000 10%, rgba(255, 255, 255, 0) 42%);
  background: -webkit-linear-gradient(
    left,
    #000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(left, #000 10%, rgba(255, 255, 255, 0) 42%);
  background: linear-gradient(to right, #000 10%, rgba(255, 255, 255, 0) 42%);
}

.submit:hover .loader:after {
  background: #fff;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
